import { useUsers } from "../../Misc/firebase"
import BlogContainer from "./Components/BlogContainer/BlogContainer"
import BlogWriter from "./Components/BlogWriter/BlogWriter"
export default function BlogPage(){
    const loggedin = useUsers()
    return (
        <div className="blogpage">
            <div className="title text-center text-5xl my-10">
                My Blog
            </div>
            {
                loggedin ?<BlogWriter/> : <BlogContainer/>
            }
        </div>
    )
}